var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuspendedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8297 3.66819C16.1409 3.66819 16.4 3.90075 16.4 4.19667V4.47026C16.4 4.75898 16.1409 4.99874 15.8297 4.99874H2.57108C2.25909 4.99874 2 4.75898 2 4.47026V4.19667C2 3.90075 2.25909 3.66819 2.57108 3.66819H4.90365C5.37748 3.66819 5.78984 3.36507 5.89643 2.9374L6.01859 2.44636C6.20843 1.77749 6.8332 1.33325 7.54822 1.33325H10.8518C11.559 1.33325 12.1908 1.77749 12.3736 2.41108L12.5043 2.93668C12.6102 3.36507 13.0225 3.66819 13.4971 3.66819H15.8297ZM14.6461 13.6698C14.8896 11.6271 15.3159 6.77438 15.3159 6.72542C15.3315 6.5771 15.2778 6.4367 15.1712 6.32366C15.0569 6.21782 14.9121 6.15518 14.7526 6.15518H3.65621C3.49593 6.15518 3.34343 6.21782 3.23762 6.32366C3.13025 6.4367 3.07734 6.5771 3.08512 6.72542C3.08655 6.73441 3.10185 6.90535 3.12743 7.19113C3.24106 8.46067 3.55752 11.9966 3.76202 13.6698C3.90674 14.9024 4.80538 15.6771 6.10704 15.7052C7.11149 15.7261 8.14629 15.7333 9.20443 15.7333C10.2011 15.7333 11.2133 15.7261 12.2489 15.7052C13.5957 15.6843 14.4936 14.9233 14.6461 13.6698Z",
    fill: "#FC0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspendedIcon);
export default __webpack_public_path__ + "static/media/suspended-icon.aa0b624a24711dfbb23bac80f28adff9.svg";
export { ForwardRef as ReactComponent };